import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from 'src/components/utils';

function RelatorioExtratoPontuacaoIndividualSintetico() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {}, requireds: {} });

  const reportCfg = {
    label: utils.lng('extrato_de_pontuacao_individual', 'Extrato de Pontuação Individual')+" ("+utils.lng('sintetico', 'Sintético')+")",
    name: 'reportCfg',
    add: false,
    print:true,
    type: 'list',
    list: {
      url: 'report_sintetico_extratoPontuacaoIndividual'
    },
    filters: {
      date: {
        type: 'date',
        range: true,
        dateFormat: 'long',
        label: utils.lng("data", "Data")
      },
      id_cliente: {
        type: 'entity',
        entity: 'Cliente',
        label: utils.lng('cliente', "Cliente"),
        list: { url: utils.getUser().administrativo === true ? 'endpoint_listar_all_clientes' : 'endpoint_listar_clientes_minha_rede' },
        itemLabel: 'nome',
        itemValue: 'id'
      },
      id_filial: {
        type: 'complete',
        label: utils.lng('filial', "Filial"),
        list: { url: 'endpoint.listar.filial' },
        itemLabel: 'nome',
        itemValue: 'id'
      },
      id_tipo_movimento: {
        type: 'select',
        label: utils.lng('tipo_movimento', "Tipo Movimento"),
        list:{url: 'TipoMovimento'},
        itemLabel: 'descricao',
        itemValue: 'id'
      },
      id_condicao_pagto: {
        type: 'select',
        label: utils.lng('forma_pagamento', "Forma Pagamento"),
        list:{url: 'HubCondicaoPagamento'},
        itemLabel: 'nome',
        itemValue: 'id'
      }
    },
    columns: {
      codigo: { field: 'codigo_mundial', label: utils.lng('codigo', 'Código'), filter: false, sort: false },
      nome: { field: 'nome_cliente', label: utils.lng('nome', 'Nome'), filter: false, sort: false },
      filial: { field: 'fantasia_filial', label: utils.lng('filial', 'Filial'), filter: false, sort: false },
      dataCadastroCliente: { field: 'data_cadastro_cliente', type: 'date', label: utils.lng('data_cadastro', 'Data Cadastro'), filter: false, sort: false },
      dataRegistroPenn: { field: 'data_registro_penn', type: 'date', label: utils.lng('data_registro_penn', 'Data Registro Penn'), filter: false, sort: false },
      dataUltimaCompra: { field: 'data_ultima_compra', type: 'date', label: utils.lng('data_ultima_compra', 'Data Última Compra'), filter: false, sort: false },
      formasPagto: { field: 'formas_pagamento', label: utils.lng('formas_de_pagamento', 'Formas de Pagamento'), filter: false, sort: false },
      totalPontos: { aggregate: 'sum', field: 'total_pontos', format: 'number', decimalCount: 4, label: utils.lng('total_pontos', 'Total de Pontos'), filter: false, sort: false },
      estorno: { field: 'is_estorno', label: utils.lng('estorno', 'Estorno'), filter: false, sort: false }
    }
  };

  return (
    <View name="rel-extrato-pontuacao-individual-sintetico" className="ui-view-report">
      <Element value={reportCfg} crud={crud} data={crud.data} view={view} ></Element>
    </View>
  );
}

export default RelatorioExtratoPontuacaoIndividualSintetico;